import { FormContainer } from "@rhc-shared-components/form";
import { FormRadio } from "@rhc-shared-components/form-radio-select";
import { FormSelect } from "@rhc-shared-components/form-select-component";
import { Formik } from "formik";
import { type FC, forwardRef } from "react";
import { ProjectContainerTypes, ProjectRedhatKeys } from "../../../../constants/project";
import { useCreateModalStore } from "../CreateModalStore";
import {
	ComponentTypes,
	CreateFormKeys,
	EOSContentTypes,
	OpenStackInfraProjectInitialValue,
	OpenStackInfraServicesOptions,
	OpenStackInfraValidators,
	OpenStackPfDistOptions,
	ProjectContainerKeys,
	ProjectCreateModalKeys,
	ProjectDistributionMethodName,
	ProjectNonContKeys,
	useCreateAndAttachComponent,
	useCreateAndAttachNonContainerComponent,
} from "../createConstants";

interface OpenStackInfraCreateFormProps {
	handleCreateModal: (showModal: boolean) => void;
	ref: any;
}

export const OpenStackInfraCreateForm: FC<OpenStackInfraCreateFormProps> = forwardRef((props, ref: any) => {
	const { modalData } = useCreateModalStore();
	const { createNewComponent } = useCreateAndAttachComponent(props.handleCreateModal, "new");
	const { createNewNonContainerComponent } = useCreateAndAttachNonContainerComponent(props.handleCreateModal, "new");
	return (
		<Formik
			innerRef={ref}
			initialValues={OpenStackInfraProjectInitialValue}
			validationSchema={OpenStackInfraValidators}
			onSubmit={async (values) => {
				if (values?.[CreateFormKeys.partOfRhopDist] === "no") {
					const requestData = {
						[ProjectCreateModalKeys.name]: modalData.componentName,
						[ProjectCreateModalKeys.redhat]: {
							[ProjectRedhatKeys.productName]: "OpenStack",
							[ProjectRedhatKeys.productVersion]: modalData.productVersion,
						},
						[ProjectCreateModalKeys.type]: ComponentTypes.openStackInfraContainer,
						[ProjectCreateModalKeys.projectStatus]: "active",
						[ProjectCreateModalKeys.openstack]: {
							service: values?.[CreateFormKeys.services],
						},
						[ProjectCreateModalKeys.container]: {
							[ProjectContainerKeys.distributionMethod]: ProjectDistributionMethodName.redHatContainerRegistry,
							[ProjectContainerKeys.osContentType]: EOSContentTypes.RHEL,
							[ProjectContainerKeys.type]: ProjectContainerTypes.container,
							[ProjectCreateModalKeys.allowHostedRegistry]: true,
						},
						[ProjectCreateModalKeys.marketplace]: {
							enablement_status: "ineligible",
						},
					};
					await createNewComponent(requestData);
				} else {
					const requestData = {
						[ProjectCreateModalKeys.name]: modalData.componentName,
						[ProjectNonContKeys.projectStatus]: { code: "active" },
						service: {
							code: values?.[CreateFormKeys.services],
						},
						[ProjectNonContKeys.rhProductName]: "OpenStack",
						[ProjectNonContKeys.rhProductVersion]: modalData.productVersion,
						[ProjectNonContKeys.type]: { code: ComponentTypes.openStackInfraNonContainer },
					};
					await createNewNonContainerComponent.mutateAsync(requestData);
				}
			}}
		>
			<FormContainer gridSpan={12}>
				<FormRadio
					name={CreateFormKeys.partOfRhopDist}
					label={`Are your product's containers already a part of the Red Hat OpenStack Platform distribution?`}
					isRequired={true}
					options={OpenStackPfDistOptions}
					span={12}
				/>
				<FormSelect
					name={CreateFormKeys.services}
					placeholder={"Select Service"}
					label={"Services"}
					isFullWidth
					selectOptions={OpenStackInfraServicesOptions}
					isRequired={true}
				/>
			</FormContainer>
		</Formik>
	);
});
